import { OrderPaymentStatus, OrderType } from '@leid/api-orders'
import { PaymentProvider } from '@leid/api-payments'
import { SortingDirection } from '@leid/client'

export const tryParseAsValidLocaleString = (locale: unknown): string | undefined => {
  if (!locale) return undefined

  if (Array.isArray(locale)) locale = locale.toString()

  if (
    locale === 'no' ||
    locale === 'NO' ||
    locale === 'nb_NO' ||
    locale === 'nb-NO' ||
    locale === 'no-NO' ||
    locale === 'no_NO'
  )
    return 'no-NO'

  if (locale === 'en' || locale === 'EN' || locale === 'enUS' || locale === 'en_US' || locale === 'en-US')
    return 'en-US'
}

export function tryParseAsNumber(input: unknown, signedNumber = false): number | undefined {
  if (!input) {
    return undefined
  }
  const numberVal = Number(input)
  if (Number.isNaN(numberVal)) {
    return undefined
  }
  if (!signedNumber && numberVal < 0) {
    return 0
  }
  return numberVal
}

export function tryParseAsBoolean(input: unknown): boolean | undefined {
  if (input === true) return true
  if (input === false) return false

  if (!input) return undefined

  if (input === 'true') return true
  if (input === 'false') return false
  return undefined
}

export function tryParseAsCountryCode(input: unknown): string | undefined {
  if (typeof input === 'string' && input.length === 2) {
    return input
  }
  return undefined
}

export function tryParseAsNull(input: unknown): null | undefined {
  if (!input) {
    return undefined
  }
  if (input === 'null') {
    return null
  }
  return undefined
}

const isNullOrEmpty = (str?: string): boolean => {
  if (!str) {
    return true
  }
  if (str.trim().length === 0) {
    return true
  }
  return false
}

export function tryParseAsPaymentProvider(input: string | undefined): PaymentProvider | undefined {
  if (!input || isNullOrEmpty(input)) {
    return undefined
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const enumValue: PaymentProvider | undefined = (<any>PaymentProvider)[input]
  return enumValue
}

export function tryParseAsOrderType(input: string | undefined): OrderType | undefined {
  if (!input || isNullOrEmpty(input)) {
    return undefined
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const enumValue: OrderType | undefined = (<any>OrderType)[input]
  return enumValue
}

export function tryParseAsOrderPaymentStatus(input: string | undefined): OrderPaymentStatus | undefined {
  if (!input || isNullOrEmpty(input)) {
    return undefined
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const enumValue: OrderPaymentStatus | undefined = (<any>OrderPaymentStatus)[input]
  return enumValue
}

export function tryParseAsSortingDirection(input: string): SortingDirection | undefined {
  if (isNullOrEmpty(input)) {
    return undefined
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const enumValue: SortingDirection | undefined = (<any>SortingDirection)[input]
  return enumValue
}
